import * as React from "react";
import { withApollo } from "react-apollo";

import DatePicker from "material-ui/DatePicker";
import BODebounceInput from "app/components/BOComponents/BODebounceInput";

import AllPaymentsContainer from "app/components/AppComponents/Payments/AllPaymentsContainer";

type Props = {
  setHeader: any;
  client: any;
  history: any;
};

type State = {
  reference: string;
  createdAtFrom: string;
  createdAtTo: string;
};

class List extends React.Component<Props, State> {
  state = {
    reference: null,
    createdAtFrom: null,
    createdAtTo: null
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Payments",
      description: "SnapScan payments"
    });
  }

  updateDateFrom = (event: any, date: Date): void => {
    this.setState({ createdAtFrom: date.toISOString() });
  };

  updateDateTo = (event: any, date: Date): void => {
    this.setState({ createdAtTo: date.toISOString() });
  };

  render() {
    return (
      <section className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start"
          }}
        >
          <DatePicker
            hintText="From"
            onChange={this.updateDateFrom}
            style={{
              width: "200px",
              marginRight: "10px"
            }}
            textFieldStyle={{
              width: "200px"
            }}
          />
          <DatePicker
            hintText="To"
            onChange={this.updateDateTo}
            style={{
              width: "200px",
              marginRight: "10px"
            }}
            textFieldStyle={{
              width: "200px"
            }}
          />
          <BODebounceInput
            style={{ width: "25%" }}
            minLength={2}
            debounceTimeout={300}
            placeholder="Search Payment by Reference"
            onChange={newValue => {
              this.setState({ reference: newValue });
            }}
          />
        </div>

        <AllPaymentsContainer
          name={"ops.payments.list"}
          createdAtFrom={this.state.createdAtFrom}
          createdAtTo={this.state.createdAtTo}
          reference={this.state.reference}
          history={this.props.history}
        />
      </section>
    );
  }
}

export default withApollo(List);
